import React from "react";

import { getValue } from "../../utils";

const TextWithIcon = props => {
  const value = getValue(props);
  const icon = value.icon;

  return (
    <div
      style={{
        width: "100%",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis"
      }}
    >
      {icon ? (
        <span
          style={{ fontSize: 14, width: 14, height: 14, margin: 8 }}
          className="material-icons-outlined"
        >
          {icon}
        </span>
      ) : null}
      {value.value}
    </div>
  );
};

export default TextWithIcon;
